import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/button';
import styles from './report.module.scss';

const ReportHazard = ({ airport }) => {
  const history = useHistory();
  const handleReview = () => {
    history.push(`/safety_management/us/${airport.code}`);
  };
  return (
    <div className={styles.report}>
      <div className={styles.title}>
        <FormattedMessage
          id="reporthazard.system.management.system"
          defaultMessage="Safety Management System"
        />
      </div>
      <span className={styles.review}>
        <Button
          onClick={handleReview}
          translationID="reportNewHazard"
          defaultText="Report New Hazard"
        />
      </span>
    </div>
  );
};

export default ReportHazard;
